export const RESOLVE_USER_SELECT_MODAL = 'APP_COMMON.RESOLVE_USER_SELECT_MODAL';
export const REJECT_USER_SELECT_MODAL = 'APP_COMMON.REJECT_USER_SELECT_MODAL';

export const ON_SEARCH_CHANGE = 'USER_SELECT_MODAL.ON_SEARCH_CHANGE';
export const ON_SEARCH_DATA = 'USER_SELECT_MODAL.ON_SEARCH_DATA';
